import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'

interface Props {}

export const DemolitionTechnicalFormB4: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<any>
  return (
    <>
      <FormSectionTwoColumns
        title="a) potřeby a spotřeby rozhodujících médií a jejich zajištění"
        subtitle=""
        sectionKey="b4.demolitionOrganization.mediaNeeds"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.mediaNeeds.enabled"
            label="Potřeby a spotřeby rozhodujících médií"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.mediaNeeds?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.mediaNeeds.description"
              label=""
              component={RichTextInput}
              aiHint="Potřeby a spotřeby rozhodujících médií a jejich zajištění při bouracích pracích"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="b) odvodnění staveniště"
        subtitle=""
        sectionKey="b4.demolitionOrganization.siteDrainage"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.siteDrainage.enabled"
            label="Odvodnění staveniště"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.siteDrainage?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.siteDrainage.description"
              label=""
              component={RichTextInput}
              aiHint="Odvodnění staveniště při bouracích pracích"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="c) napojení staveniště na stávající dopravní a technickou infrastrukturu"
        subtitle=""
        sectionKey="b4.demolitionOrganization.siteConnection"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.siteConnection.enabled"
            label="Napojení staveniště na infrastrukturu"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.siteConnection?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.siteConnection.description"
              label=""
              component={RichTextInput}
              aiHint="Napojení staveniště na stávající dopravní a technickou infrastrukturu při bouracích pracích"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="d) vliv odstraňování staveb na okolní stavby a pozemky včetně ochrany okolí staveniště"
        subtitle=""
        sectionKey="b4.demolitionOrganization.impactOnSurroundings"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.impactOnSurroundings.enabled"
            label="Vliv na okolní stavby a pozemky"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.impactOnSurroundings?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.impactOnSurroundings.description"
              label=""
              component={RichTextInput}
              aiHint="Vliv odstraňování staveb na okolní stavby a pozemky včetně ochrany okolí staveniště"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="e) maximální zábory"
        subtitle=""
        sectionKey="b4.demolitionOrganization.maximumOccupancy"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.maximumOccupancy.enabled"
            label="Maximální zábory"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.maximumOccupancy?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.maximumOccupancy.description"
              label=""
              component={RichTextInput}
              aiHint="Maximální zábory při bouracích pracích"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="f) požadavky na obchozí trasy pro osoby s omezenou schopností pohybu nebo orientace"
        subtitle=""
        sectionKey="b4.demolitionOrganization.accessibilityRequirements"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.accessibilityRequirements.enabled"
            label="Požadavky na obchozí trasy"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.accessibilityRequirements?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.accessibilityRequirements.description"
              label=""
              component={RichTextInput}
              aiHint="Požadavky na obchozí trasy pro osoby s omezenou schopností pohybu nebo orientace při bouracích pracích"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="g) maximální produkovaná množství, druhy a kategorie odpadů a emisí při odstraňování staveb"
        subtitle="nakládání s odpady, zejména s azbestem a jiným nebezpečným odpadem, způsob přepravy, uložení, odstranění nebo využití, včetně vyhodnocení možnosti opětovného využití nebo recyklovatelnosti materiálů a konstrukcí a selektivního třídění pro budoucí materiálové využití, popis opatření proti kontaminaci materiálů, stavby a jejího okolí, opatření při nakládání s azbestem"
        sectionKey="b4.demolitionOrganization.wasteManagement"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.wasteManagement.enabled"
            label="Nakládání s odpady"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.wasteManagement?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.wasteManagement.description"
              label=""
              component={RichTextInput}
              aiHint="Nakládání s odpady při bouracích pracích, včetně azbestu a jiných nebezpečných odpadů"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="h) ochrana životního prostředí a veřejného zdraví při odstraňování stavby"
        subtitle=""
        sectionKey="b4.demolitionOrganization.environmentalProtection"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.environmentalProtection.enabled"
            label="Ochrana životního prostředí"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.environmentalProtection?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.environmentalProtection.description"
              label=""
              component={RichTextInput}
              aiHint="Ochrana životního prostředí a veřejného zdraví při odstraňování stavby"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="i) zásady bezpečnosti a ochrany zdraví při práci na staveništi"
        subtitle="při zjištění výskytu azbestového materiálu ve stavbě specifikovat opatření a postupy odpovídající požadavkům bezpečnosti a ochrany zdraví při práci s azbestem"
        sectionKey="b4.demolitionOrganization.safetyPrinciples"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.safetyPrinciples.enabled"
            label="Zásady bezpečnosti a ochrany zdraví"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.safetyPrinciples?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.safetyPrinciples.description"
              label=""
              component={RichTextInput}
              aiHint="Zásady bezpečnosti a ochrany zdraví při práci na staveništi, včetně postupů při práci s azbestem"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="j) úpravy pro bezbariérové užívání staveb dotčených odstraněním stavby"
        subtitle="na podkladu katastrální mapy"
        sectionKey="b4.demolitionOrganization.barrierFreeModifications"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.barrierFreeModifications.enabled"
            label="Úpravy pro bezbariérové užívání"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.barrierFreeModifications?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.barrierFreeModifications.description"
              label=""
              component={RichTextInput}
              aiHint="Úpravy pro bezbariérové užívání staveb dotčených odstraněním stavby na podkladu katastrální mapy"
            />
          </div>
        )}
      </FormSectionTwoColumns>

      <FormSectionTwoColumns
        title="k) zásady pro dopravně inženýrská opatření"
        subtitle=""
        sectionKey="b4.demolitionOrganization.trafficMeasures"
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b4.demolitionOrganization.trafficMeasures.enabled"
            label="Zásady pro dopravně inženýrská opatření"
          />
        </div>
        {formik?.values.b4?.demolitionOrganization?.trafficMeasures?.enabled && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b4.demolitionOrganization.trafficMeasures.description"
              label=""
              component={RichTextInput}
              aiHint="Zásady pro dopravně inženýrská opatření při bouracích pracích"
            />
          </div>
        )}
      </FormSectionTwoColumns>
    </>
  )
}
